/**
 * Real-world physical dimensions for a brick mosaic.
 * 1 stud pitch = 8 mm (LEGO module). Baseplates are 32×32 studs.
 */

export const STUD_PITCH_MM = 8;
export const BASEPLATE_STUDS = 32;

export interface PhysicalSize {
  widthMm: number;
  heightMm: number;
  widthCm: number;
  heightCm: number;
  widthIn: number;
  heightIn: number;
  /** How many 32×32 baseplates are needed to lay the mosaic flat */
  baseplates: number;
}

const round1 = (n: number) => Math.round(n * 10) / 10;

export function physicalSize(
  widthStuds: number,
  heightStuds: number,
): PhysicalSize {
  const widthMm = widthStuds * STUD_PITCH_MM;
  const heightMm = heightStuds * STUD_PITCH_MM;

  return {
    widthMm,
    heightMm,
    widthCm: round1(widthMm / 10),
    heightCm: round1(heightMm / 10),
    widthIn: round1(widthMm / 25.4),
    heightIn: round1(heightMm / 25.4),
    baseplates:
      Math.ceil(widthStuds / BASEPLATE_STUDS) *
      Math.ceil(heightStuds / BASEPLATE_STUDS),
  };
}
